/**
 * 获取竞猜显示信息（标题和副标题）
 *
 * @param params
 * @param params.guessGroupNo 聚合组编号
 * @param params.groupTitle 聚合标题
 * @param params.guessTitle 竞猜标题
 * @param params.guessCategoryId 竞猜分类 ID
 */
export function getGuessDisplayInfo(
    params: { guessGroupNo?: string | null; groupTitle?: string | null; guessTitle: string; guessCategoryId?: number },
) {
    const { guessGroupNo, groupTitle, guessTitle, guessCategoryId } = params;

    // 1. 如果有聚合组，并且 groupTitle 存在，那么返回 `${groupTitle}-${guessTitle}`, 否则返回 guessTitle
    let fullTitle = guessTitle;
    if ( guessGroupNo && groupTitle ) {
        fullTitle = `${groupTitle} - ${guessTitle}`;
    }

    // 2. 如果 guessCategoryId 为 1010302, 那么需要返回 subtitle 为 runs
    let subTitle = "";
    if ( guessCategoryId === 1010302 ) {
        subTitle = "Runs";
    }
    if ( subTitle ) {
        fullTitle = `${fullTitle} ${subTitle}`;
    }

    return { fullTitle, title: guessTitle, subTitle };
}
